import { useEffect, useContext, useState } from "react";
import QlikCard from "components/QlikCard";
import QlikObject from "components/QlikObject";
import GlobalContext from "GlobalContext";
import FlaticonIcon from "components/FlaticonIcon";


export default function MTPPublicInvestmentPlan({ title , appDisclaimer , pageTitle, ExportChartFootnote, menuItemsStrings, onPageTitle, navbarObjectId, isMobile }) {
  useEffect(() => {
    document.title = `${pageTitle} - ${title}`;
    onPageTitle && onPageTitle(title);
  }, [pageTitle, title, onPageTitle]);

  const { app } = useContext(GlobalContext);
  const [err, setError] = useState(null);
  const [FilterHeightInvestmentProjects, setFilterHeight] = useState(688);

  // Year tabs — clicking a tab sets the Qlik variable mtp_sheet.
  // Layout/objects are identical on both tabs; only the variable changes.
  const TABS = [
    { key: "2027", icon: "calendar-lines", label: "2027" },
    { key: "2026", icon: "calendar-lines", label: "2026" },
  ];
  const [activeTab, setActiveTab] = useState(TABS[0].key);

  // Set mtp_sheet to the active tab (default 2027 on mount, then on each switch)
  useEffect(() => {
    app.model.waitForOpen.promise.then(() => {
      app.variable.setStringValue("mtp_sheet", activeTab);
    });
  }, [app, activeTab]);


  useEffect(() => {
    app.model.waitForOpen.promise.then(() => {
      setTimeout(async () => {
        app.model.enigmaModel.evaluate("$(=count({1}distinct [_col_id_investmentprojects]))").then(async (reply) => {
          const InvestmentProjectsNumberOfFilterRows = reply*27+40;
          console.log('InvestmentProjectsNumberOfFilterRows/Number of rows: ', InvestmentProjectsNumberOfFilterRows);
          setFilterHeight(InvestmentProjectsNumberOfFilterRows);
        }).catch(err => {
          if(!err) setError(err);
        });
      }, 500);
    });
  }, [app, err])

  return (
    <section className="content">
      <div className="content-header">
        <div className="mobile-page-header">
          <h4 className="mobile-page-title">{title}</h4>
          {navbarObjectId && isMobile && (
            <div className="mobile-page-object">
              <QlikObject
                key={`mobile-${navbarObjectId}`}
                id={navbarObjectId}
                height="30px"
                showLoader={false}
              />
            </div>
          )}
        </div>
        {/* Year tab selector — sets the mtp_sheet variable */}
        <div className="row mb-2">
          <div className="col-12">
            <ul className="nav nav-tabs spp-tabs">
              {TABS.map((tab) => (
                <li className="nav-item" key={tab.key}>
                  <button
                    type="button"
                    className={`nav-link ${activeTab === tab.key ? "active" : ""}`}
                    onClick={() => setActiveTab(tab.key)}
                  >
                    {tab.icon && (
                      <FlaticonIcon icon={tab.icon} size={16} className="tab-icon" />
                    )}
                    {tab.label}
                  </button>
                </li>
              ))}
            </ul>
          </div>
        </div>
      </div>

      <div className="container-fluid">

        <div className="row justify-content-start">

            <div className="col-xs-12 col-sm-12 col-md-12 col-lg-10 col-xl-10">

              <div className="row justify-content-left">
                {/* KPIs Row */}

                    <div className="col-xs-12 col-sm-12 col-md-6 col-lg-6 col-xl-3">
                      {/* KPI: no of total streams */}
                      <QlikCard
                        id="cee5b206-c4c8-4cdf-a79c-7907c9964cd1"
                        height="90px"
                        showHeader={false}
                        showMaximize={false}
                        showExport={false}
                      />
                    </div>

                    <div className="col-xs-12 col-sm-12 col-md-6 col-lg-6 col-xl-3">
                      {/* KPI: no of total subsectors */}
                      <QlikCard
                        id="6f0d44d9-e7be-472e-bf86-e1d19e696100"
                        height="90px"
                        showHeader={false}
                        showMaximize={false}
                        showExport={false}
                      />
                    </div>

                    <div className="col-xs-12 col-sm-12 col-md-6 col-lg-6 col-xl-3">
                      {/* KPI: total needs amount */}
                      <QlikCard
                        id="ddfe88b3-f4e3-4698-93d0-8bf90baf157b"
                        height="90px"
                        showHeader={false}
                        showMaximize={false}
                        showExport={false}
                      />
                    </div>

                    <div className="col-xs-12 col-sm-12 col-md-6 col-lg-6 col-xl-3">
                      {/* KPI: funding cap amount */}
                      <QlikCard
                        id="eqHhJr"
                        height="90px"
                        showHeader={false}
                        showMaximize={false}
                        showExport={false}
                      />
                    </div>

              </div>

              <div className="row justify-content-left">
                {/* Charts Row */}

                <div className="col-xs-12 col-sm-12 col-md-12 col-lg-12 col-xl-4">
                  {/* bar chart column */}
                  <div className="row justify-content-center">
                    <div className="col-12">
                      {/* bar chart 1*/}
                      <QlikCard
                        id="mJgrv"
                        height="min(calc(78vh - 263px), calc(320px + 38px))"
                        showHeader={true}
                        showMaximize={false}
                        showExport={true}
                        showPdfExport
                        showImageExport={true}
                        exportImageWidth={1280}
                        exportImageHeight={720}
                        onBeforeExportHandler={async ({ vis, exportType }) => {
                          //console.log(data);
                          console.log(vis);
                          if(exportType in { pdf: true, image: true} && vis)
                            await vis.setOptions({ showTitles: true, footnote: `${ExportChartFootnote}` });
                        }}
                        onAfterExportHandler={async ({ vis, exportType }) => {
                          console.log('Export type: ', exportType);
                          if(exportType in { pdf: true, image: true})
                            vis.setOptions({ showTitles: false, footnote:"" });
                        }}
                        exportText = {menuItemsStrings.exportText}
                        exportCompletedText = {menuItemsStrings.exportCompletedText}
                        closeBtnText = {menuItemsStrings.closeBtnText}
                      />
                    </div>
                  </div>

                </div>

                <div className="col-xs-12 col-sm-12 col-md-12 col-lg-12 col-xl-4">
                  {/* barchart column */}
                  <div className="row justify-content-center">
                    <div className="col-12">
                      {/* bar chart 2*/}
                      <QlikCard
                        id="TXdjcm"
                        height="min(calc(78vh - 263px), calc(320px + 38px))"
                        showHeader={true}
                        showMaximize={false}
                        showExport={true}
                        showPdfExport
                        showImageExport={true}
                        exportImageWidth={1280}
                        exportImageHeight={720}
                        onBeforeExportHandler={async ({ vis, exportType }) => {
                          //console.log(data);
                          console.log(vis);
                          if(exportType in { pdf: true, image: true} && vis)
                            await vis.setOptions({ showTitles: true, footnote: `${ExportChartFootnote}` });
                        }}
                        onAfterExportHandler={async ({ vis, exportType }) => {
                          console.log('Export type: ', exportType);
                          if(exportType in { pdf: true, image: true})
                            vis.setOptions({ showTitles: false, footnote:"" });
                        }}
                        exportText = {menuItemsStrings.exportText}
                        exportCompletedText = {menuItemsStrings.exportCompletedText}
                        closeBtnText = {menuItemsStrings.closeBtnText}
                      />
                    </div>
                  </div>
                </div>

                <div className="col-xs-12 col-sm-12 col-md-12 col-lg-12 col-xl-4">
                  {/* bar chart column */}
                  <div className="row justify-content-center">
                    <div className="col-12">
                      {/* bar chart 3*/}
                      <QlikCard
                        id="BaB"
                        height="min(calc(78vh - 263px), calc(320px + 38px))"
                        showHeader={true}
                        showMaximize={false}
                        showExport={true}
                        showPdfExport
                        showImageExport={true}
                        exportImageWidth={1280}
                        exportImageHeight={720}
                        onBeforeExportHandler={async ({ vis, exportType }) => {
                          //console.log(data);
                          console.log(vis);
                          if(exportType in { pdf: true, image: true} && vis)
                            await vis.setOptions({ showTitles: true, footnote: `${ExportChartFootnote}` });
                        }}
                        onAfterExportHandler={async ({ vis, exportType }) => {
                          console.log('Export type: ', exportType);
                          if(exportType in { pdf: true, image: true})
                            vis.setOptions({ showTitles: false, footnote:"" });
                        }}
                        exportText = {menuItemsStrings.exportText}
                        exportCompletedText = {menuItemsStrings.exportCompletedText}
                        closeBtnText = {menuItemsStrings.closeBtnText}
                      />
                    </div>
                  </div>
                  
               

                </div>

              </div>

              <div className="row justify-content-left">
                {/* Table Row */}

                <div className="col-xs-12 col-sm-12 col-md-12 col-lg-12 col-xl-12">
                  {/* pivot table */}
                  <div className="row justify-content-center">
                    <div className="col-12">
                      {/* table */}
                      <QlikCard
                        id="jxqZaU"
                        height="max(calc(100vh - 365px)/2 + 161px, 380px)"
                        showHeader={true}
                        showMaximize={true}
                        showExport={true}
                        onBeforeExportHandler={async ({  }) => {
                            await app.variable.setStringValue('export_link', '1');
                        }}
                        onAfterExportHandler={async ({  }) => {
                            app.variable.setStringValue('export_link', '0');
                        }}
                        exportText = {menuItemsStrings.exportText}
                        exportCompletedText = {menuItemsStrings.exportCompletedText}
                        closeBtnText = {menuItemsStrings.closeBtnText}
                        actionsVisibility="always"
                        copyCells="true"
                        copiedSuccessMessage={menuItemsStrings.copiedSuccessMessage}
                        copiedFailedMessage={menuItemsStrings.copiedFailedMessage}
                      />
                    </div>
                  </div>

                </div>

              </div>

            </div>

{/*             <div className="col-xs-12 col-sm-12 col-md-12 col-lg-2 col-xl-2 remove-header-spacing">
                  <QlikCard
                    id="2de5ba8a-cd73-4ed2-be44-c1aa52ef668b"
                    height="min(calc(78vh - 263px + 90px + 8px + 18.8px + 4px), calc(320px + 38px + 90px + 8px + 18.8px + 4px))"
                    showHeader={false}
                    showMaximize={false}
                    showExport={false}
                    showOverlayer={false}
                  />

            </div> */}
            <div className="col-xs-12 col-sm-12 col-md-12 col-lg-2 col-xl-2 remove-header-spacing">
                  {/* FilterPane */}
                  <QlikCard
                    id="2de5ba8a-cd73-4ed2-be44-c1aa52ef668b"
                    height="min(calc(78vh - 263px + 90px + 8px + 18.8px + 4px - 12px), calc(320px + 38px + 90px + 8px + 18.8px + 4px - 12px))"
                    showHeader={false}
                    showMaximize={false}
                    showExport={false}
                    showOverlayer={false}
                  />
                  <QlikObject
                    id="PtXRmTc"
                    height="min(calc(10.5vh + 2px), 64px)"
                    showHeader={false}
                    showMaximize={false}
                    showExport={false}
                    showOverlayer={false}
                  />
                  {/* Columns Selector */}
                  <QlikCard
                    id="kjEggVe"
                    height="max(calc(100vh - 365px)/2 - min(calc(10.5vh + 2px), 64px) - 18.8px - 2px + 161px, 380px - min(calc(10.5vh + 2px), 64px) - 18.8px - 2px)"
                    showHeader={false}
                    showMaximize={false}
                    showExport={false}
                    showOverlayer={false}
                  />

            </div>


        </div>
        <div className="row justify-content-start">
            <div className="col-xs-12 col-sm-12 col-md-12 col-lg-12 col-xl-12">

            </div>
        </div>



          {/* <div className="row mb-2">
            <div className="col-md-2 col-sm-3 col-2">
              <QlikObject
                id="b4231dd2-2ce3-4d63-b394-838d3c6f0b0e"
                height="0px"
                showLoader={false}
              />
            </div>
          </div> */}
          
      </div>
    </section>
  );
}
